import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { ADMIN, CLIENT, CLIENT_VENDOR, PROJECT_COORDINATOR,SUBMISSION_SPECIALIST } from "../constants/roles";
import React, { Suspense } from "react";

import {Dashboard,ClientPage,EmployeePage,VendorPage,ProjectPage} from "../Pages/admin/index"
import {Dash,Projects} from "../Pages/employee/index"

import {ProjectDetails,ProjectInfo,ClientDocument,UploadUserDocument} from "../Components/Feature/employee/Projects/index"
import {AddClient,ClientDetail,ClientList} from "../Components/Feature/Admin/Client/index"

import {AddEmployee,EmployeeList,EmployeeView,EmployeeTodoList} from "../Components/Feature/Admin/Employee/index"

import {AddProject,ProjectList,ProjectViewPage,AdminProjectTitle,AdminProjectInfo,AdminEmpDocument,AdminClientDocument} from "../Components/Feature/Admin/Projects/index"

import {AddVendor,VendorList, VendorProject} from "../Components/Feature/Admin/Vendor/index"
import { ClientProjectForm, ClientProjects } from "../Pages/client/index";
import {ViewClientProject,ProjectInfoForm,DocumentUploadedByEmp,UploadClientDocument, ViewProjectForm} from "../Components/Feature/clients/projects/index";
import { useSelector } from "react-redux";
import EmpolyeeFolder from "../Components/Feature/employee/Projects/folder";
import AdminFolder from "../Components/Feature/Admin/Projects/folder";
import EmpolyeeSubFolder from "../Components/Feature/employee/Projects/subFolders";
import AdminSubFolder from "../Components/Feature/Admin/Projects/subFolders";
import AdminEmpOldDocument from "../Components/Feature/Admin/Projects/oldDocument";
import EmpOldDocument from "../Components/Feature/employee/Projects/oldDocuments";
import ClientDashboard from "../Pages/client/dashboard";
import Articles from "../Pages/admin/articles";
import ArticlesJournals from "../Components/Feature/Admin/Article/articlesJournals";
import JournalDetailView from "../Components/Feature/Admin/Article/MRRJournalDetailView";
import ArticlesSubmissionSpecialist from "../Pages/submissionSpecialist/articles";
import ArticlesJournalsSUBSPEC from "../Components/Feature/submissionSpecialist/articlesJournals";
import ArticlesClient from "../Pages/client/articlesClient";
import ClientArticlesJournals from "../Components/Feature/clients/clientArticlesJournals";
const NotFound = React.lazy(()=>import("../Pages/NotFound"));
const  UnauthorizedPage = React.lazy(()=>import("../Pages/UnauthorizedPage"));
const Chat=React.lazy(()=>import('../Components/Comman/Chat'));
const ChangeYourPassword = React.lazy(()=> import('../Pages/ChangeYourPassword'));
const AppRoutes = () => {
  const user=useSelector((state)=>state?.auth?.user)

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>

      {/* ************* Admin ****************** */}
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[ADMIN]}
            element={<Dashboard />}
          />
        }
      />
      <Route
        path="/clients"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[ADMIN]}
            element={<ClientPage />}
          />
        }
      >
        <Route index element={<ClientList />} />
        <Route path="new-client" element={<AddClient />} />
      </Route>
      <Route
        path="client-details/:id"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[ADMIN]}
            element={<ClientDetail />}
          />
        }
      />

      <Route
        path="/employee"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[ADMIN]}
            element={<EmployeePage />}
          />
        }
      >
        <Route index element={<EmployeeList />} />
        <Route path="new-emp" element={<AddEmployee />} />
        <Route path="todo-list" element={<EmployeeTodoList />} />
      </Route>
      <Route
        path="emp-details/:id"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[ADMIN]}
            element={<EmployeeView />}
          />
        }
      />

      <Route
        path="/vendor"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[ADMIN]}
            element={<VendorPage />}
          />
        }
      >
        <Route index element={<VendorList />} />
        <Route path="new-vendor" element={<AddVendor />} />
      </Route>
      <Route
        path="vendor-details/:id"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[ADMIN]}
            element={<VendorProject />}
          />
        }
      />
      <Route
        path="/projects"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[ADMIN]}
            element={<ProjectPage />}
          />
        }
      >
      <Route index element={<ProjectList />} />
      <Route path="new-project" element={<AddProject />} />
      </Route>
      <Route path="/view-project/:id" 
      element={
        <ProtectedRoute user={user} allowedRole={[ADMIN]} element={<ProjectViewPage />} />
      }>
      <Route index element={<AdminProjectTitle />} />
      <Route path="project-info" element={<AdminProjectInfo />} />
      <Route path="emp-doc" element={<AdminFolder />} />
      <Route path="client-doc" element={<AdminClientDocument />} />
      <Route path="chat" element={<Chat />} />
      <Route path="old-doc" element={<AdminEmpOldDocument />} />
      </Route>

      <Route 
        path="/view-project/:id/emp-doc-subfolder/:mainFolderId" 
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[ADMIN]}
            element={<AdminSubFolder />}
          />
        } />

      <Route
        path="/view-project/emp-doc/documents/:projectId/:mainFolderId/:subFolderId"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[ADMIN]}
            element={<AdminEmpDocument />}
          />
        }
      />   

      <Route
        path="/admin/articles"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[ADMIN]}
            element={<Articles />}
          />
        }
      />

      <Route
        path="/admin/articles-journals"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[ADMIN]}
            element={<ArticlesJournals />}
          />
        }
      />

      <Route
        path="/journal-details/:articleId"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[ADMIN,SUBMISSION_SPECIALIST,CLIENT,CLIENT_VENDOR]}
            element={<JournalDetailView />}
          />
        }
      />
       
       


       {/* ************* Project Co-Ordinator ****************** */}
      <Route
        path="/project-coordinator/dashboard"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[PROJECT_COORDINATOR]}
            element={<Dash />}
          />
        }
      />
      <Route
        path="/emp-projects"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[PROJECT_COORDINATOR]}
            element={<Projects />}
          />
        }
      />

      <Route
        path="/emp-projects-details/:id"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[PROJECT_COORDINATOR]}
            element={<ProjectDetails />}
          />
        }
      >
        <Route index element={<ProjectInfo />} />
        <Route path="client-doc" element={<ClientDocument />} />
        {/* <Route path="" element={<UploadUserDocument />} /> */}
        <Route path="user-doc" element={<EmpolyeeFolder />} />
        <Route path="chat" element={<Chat />} />
        <Route path="old-doc" element={<EmpOldDocument />} />
      </Route>

      <Route 
        path="/emp-projects-details/:id/user-doc-subfolder/:mainFolderId" 
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[PROJECT_COORDINATOR]}
            element={<EmpolyeeSubFolder />}
          />
        } />

      <Route
        path="/emp-projects/user-doc/documents/:projectId/:mainFolderId/:subFolderId"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[PROJECT_COORDINATOR]}
            element={<UploadUserDocument />}
          />
        }
      />

       {/* ************* Client and Vendor ****************** */}

        <Route
          path="/client/dashboard"
          element={
            <ProtectedRoute
              user={user}
              allowedRole={[CLIENT,CLIENT_VENDOR]}
              element={<ClientDashboard />}
            />
          }
        />

        <Route path="/add-project-info" element={
        <ProtectedRoute user={user} allowedRole={[CLIENT,CLIENT_VENDOR]} element={<ClientProjectForm />} />
      } />
      <Route path="/client-projects" element={
        <ProtectedRoute user={user} allowedRole={[CLIENT_VENDOR,CLIENT]} element={<ClientProjects />} />
      } />

      <Route
        path="/client-project-details/:id"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[CLIENT,CLIENT_VENDOR]}
            element={<ViewClientProject />}
          />
        }
      >
        <Route index element={<ProjectInfoForm />} />
        <Route path="user-doc" element={<DocumentUploadedByEmp />} />
        <Route path="client-doc" element={<UploadClientDocument />} />
        <Route path="chat" element={<Chat />} />
      </Route>
      <Route path="/client/view-project-details" element={
        <ProtectedRoute user={user} allowedRole={[CLIENT,CLIENT_VENDOR]} element={<ViewProjectForm /> } />
      } />

      <Route
        path="/client/articles"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[CLIENT,CLIENT_VENDOR]}
            element={<ArticlesClient />}
          />
        }
      />

      <Route
        path="/client/articles-journals"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[CLIENT,CLIENT_VENDOR]}
            element={<ClientArticlesJournals />}
          />
        }
      />
      

      <Route
        path="/submission-specialist/articles"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[SUBMISSION_SPECIALIST]}
            element={<ArticlesSubmissionSpecialist />}
          />
        }
      />

      <Route
        path="/submission-specialist/articles-journals"
        element={
          <ProtectedRoute
            user={user}
            allowedRole={[SUBMISSION_SPECIALIST]}
            element={<ArticlesJournalsSUBSPEC />}
          />
        }
      />


      <Route path="/setting" element={<ChangeYourPassword />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      <Route path="*" element={<NotFound />} />
      </Routes>

    </Suspense>
   
  );
};

export default AppRoutes;
